<mat-form-field appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    #selectElem
    [formControl]="selectFormControl"
    [placeholder]="placeholder"
    [multiple]="multiple">

    <div class="search-input-wrapper" (click)="$event.stopPropagation()">
      <input
        #searchInput
        matInput
        [formControl]="searchControl"
        placeholder="Search..."
        class="search-input"
        autocomplete="off" />
      <button
        *ngIf="searchControl.value"
        mat-icon-button
        aria-label="Clear search"
        (click)="clearSearch($event)"
        class="clear-search-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-option *ngIf="(filteredOptions$ | async)?.length === 0 && searchControl.value">
      {{ noEntriesFoundLabel }}
    </mat-option>

    <mat-option *ngFor="let option of filteredOptions$ | async; trackBy: trackByOptionValue"
    [value]="option.value"
    (onSelectionChange)="handleOptionToggle($event, option.value)">
      {{ option.display }}
    </mat-option>
  </mat-select>
</mat-form-field>
